import { render, staticRenderFns } from "./ticket-prices-record.vue?vue&type=template&id=202502af&"
import script from "./ticket-prices-record.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports